import { Redo2, Undo2 } from "lucide-react";
import { useEffect, useState, type ReactNode } from "react";
import { ScratchPadMode, ScratchPadTool } from "./types";

// Custom SVG Icons
const PencilIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.38528 2.13135C7.18958 2.93564 7.97233 3.72558 8.77663 4.52988C8.72636 4.58733 8.66173 4.65914 8.58992 4.73095C6.88797 6.4329 5.1932 8.14203 3.47689 9.82962C3.26145 10.0379 2.96702 10.1959 2.68695 10.2964C2.0191 10.519 1.33688 10.6985 0.661847 10.8853C0.245336 11.0002 -0.092182 10.6842 0.0227176 10.2605C0.230973 9.4921 0.460772 8.72371 0.697753 7.95532C0.748021 7.79733 0.85574 7.64653 0.970639 7.52445C2.7444 5.7435 4.51816 3.96974 6.29911 2.1888C6.32065 2.18162 6.34938 2.16007 6.38528 2.13135Z"
      fill="currentColor"
    />
    <path
      d="M9.3304 3.97696C8.5261 3.16548 7.73616 2.37554 6.96777 1.59279C7.36274 1.18346 7.76489 0.71668 8.21731 0.314532C8.70563 -0.123523 9.4453 -0.0947983 9.94798 0.343256C10.1706 0.537149 10.3789 0.745405 10.5727 0.968023C11.018 1.47789 11.0252 2.24628 10.5727 2.74897C10.1778 3.17266 9.74691 3.56045 9.3304 3.97696Z"
      fill="currentColor"
    />
  </svg>
);

const TextBoxIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_95_15767)">
      <rect width="13.6364" height="13.6364" fill="white" />
      <path
        d="M0.90918 2.50012H1.36373V11.1365H0.90918V2.50012Z"
        fill="currentColor"
      />
      <path
        d="M12.9545 11.5909H12.0454C11.7943 11.5909 11.5908 11.7944 11.5908 12.0455V12.9546C11.5908 13.2056 11.7943 13.4091 12.0454 13.4091H12.9545C13.2055 13.4091 13.409 13.2056 13.409 12.9546V12.0455C13.409 11.7944 13.2055 11.5909 12.9545 11.5909Z"
        fill="currentColor"
      />
      <path
        d="M12.2725 2.50012H12.727V11.1365H12.2725V2.50012Z"
        fill="currentColor"
      />
      <path
        d="M2.5 0.909058H11.1364V1.3636H2.5V0.909058Z"
        fill="currentColor"
      />
      <path
        d="M1.5902 0.227295H0.681108C0.430069 0.227295 0.226562 0.430802 0.226562 0.68184V1.59093C0.226562 1.84197 0.430069 2.04548 0.681108 2.04548H1.5902C1.84124 2.04548 2.04474 1.84197 2.04474 1.59093V0.68184C2.04474 0.430802 1.84124 0.227295 1.5902 0.227295Z"
        fill="currentColor"
      />
      <path
        d="M12.9545 0.227295H12.0454C11.7943 0.227295 11.5908 0.430802 11.5908 0.68184V1.59093C11.5908 1.84197 11.7943 2.04548 12.0454 2.04548H12.9545C13.2055 2.04548 13.409 1.84197 13.409 1.59093V0.68184C13.409 0.430802 13.2055 0.227295 12.9545 0.227295Z"
        fill="currentColor"
      />
      <path
        d="M1.5902 11.5909H0.681108C0.430069 11.5909 0.226562 11.7944 0.226562 12.0455V12.9546C0.226562 13.2056 0.430069 13.4091 0.681108 13.4091H1.5902C1.84124 13.4091 2.04474 13.2056 2.04474 12.9546V12.0455C2.04474 11.7944 1.84124 11.5909 1.5902 11.5909Z"
        fill="currentColor"
      />
      <path d="M2.5 12.2728H11.1364V12.7274H2.5V12.2728Z" fill="currentColor" />
      <path
        d="M7.7277 3.86376H9.54588C9.54575 3.95646 9.56452 4.04822 9.60105 4.13342C9.63758 4.21862 9.6911 4.29547 9.75834 4.35929C9.82558 4.4231 9.90513 4.47254 9.99212 4.50457C10.0791 4.5366 10.1717 4.55055 10.2643 4.54558C10.4431 4.52971 10.6092 4.4465 10.729 4.31278C10.8488 4.17907 10.9133 4.00484 10.9095 3.82535V3.18194C10.9095 3.00111 10.8377 2.82769 10.7098 2.69982C10.582 2.57196 10.4085 2.50012 10.2277 2.50012H3.40952C3.22869 2.50012 3.05526 2.57196 2.9274 2.69982C2.79953 2.82769 2.7277 3.00111 2.7277 3.18194V3.82535C2.72388 4.00484 2.7884 4.17907 2.90819 4.31278C3.02798 4.4465 3.1941 4.52971 3.37293 4.54558C3.46549 4.55055 3.5581 4.5366 3.6451 4.50457C3.73209 4.47254 3.81164 4.4231 3.87888 4.35929C3.94612 4.29547 3.99964 4.21862 4.03617 4.13342C4.0727 4.04822 4.09147 3.95646 4.09134 3.86376H5.90952C5.96979 3.86376 6.0276 3.8877 6.07022 3.93032C6.11285 3.97295 6.13679 4.03075 6.13679 4.09103V9.77285C6.13679 9.83313 6.11285 9.89093 6.07022 9.93356C6.0276 9.97618 5.96979 10.0001 5.90952 10.0001H5.26634C5.08683 9.99619 4.91254 10.0606 4.77877 10.1804C4.645 10.3002 4.56175 10.4663 4.54588 10.6451C4.54087 10.7377 4.5548 10.8303 4.58682 10.9174C4.61884 11.0044 4.66826 11.084 4.73208 11.1512C4.7959 11.2185 4.87277 11.272 4.95799 11.3086C5.0432 11.3451 5.13498 11.3639 5.2277 11.3638H8.37088C8.55038 11.3677 8.72467 11.3032 8.85844 11.1835C8.99221 11.0637 9.07547 10.8976 9.09134 10.7188C9.09634 10.6262 9.08241 10.5335 9.0504 10.4465C9.01838 10.3595 8.96895 10.2799 8.90514 10.2127C8.84132 10.1454 8.76445 10.0919 8.67923 10.0553C8.59401 10.0188 8.50224 9.99999 8.40952 10.0001H7.7277C7.66742 10.0001 7.60961 9.97618 7.56699 9.93356C7.52437 9.89093 7.50043 9.83313 7.50043 9.77285V4.09103C7.50043 4.03075 7.52437 3.97295 7.56699 3.93032C7.60961 3.8877 7.66742 3.86376 7.7277 3.86376Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_95_15767">
        <rect width="13.6364" height="13.6364" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ImageIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.5"
      y="3"
      width="14"
      height="11"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.4"
    />
    <circle
      cx="5.5"
      cy="6.5"
      r="1.25"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <path
      d="M1.5 11.5L5.5 8L8.5 10.5L11 8.5L15.5 12.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EraserIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_95_15778)">
      <path
        d="M7.47487 2.94815C7.32508 2.79839 7.32508 2.55555 7.47487 2.40578C7.62463 2.25601 7.86748 2.25601 8.01724 2.40578L9.82711 4.21565C9.9769 4.36541 9.9769 4.60826 9.82711 4.75802C9.75222 4.8329 9.65407 4.87037 9.55593 4.87037C9.4578 4.87037 9.35964 4.8329 9.28476 4.75802L7.47487 2.94815ZM12.2727 11.8482C12.2727 12.06 12.101 12.2317 11.8892 12.2317C11.8892 12.2317 4.32996 12.2329 4.32993 12.2329C3.92242 12.233 3.51365 12.103 3.16911 11.888C3.0174 11.7933 2.87703 11.6802 2.75063 11.5538L0.679107 9.48225C-0.150069 8.6531 -0.23128 7.3852 0.498013 6.65588L6.61609 0.537809C7.34543 -0.191507 8.61335 -0.110248 9.44248 0.718904L11.514 2.79043C12.3432 3.61961 12.4244 4.88751 11.6951 5.61682L5.84724 11.4646H11.8892C12.101 11.4646 12.2727 11.6363 12.2727 11.8482ZM2.54598 5.69267L6.54022 9.68691L11.1527 5.07443C11.5829 4.64419 11.5017 3.86288 10.9716 3.33278L8.90009 1.26125C8.59902 0.960187 8.21684 0.803902 7.86405 0.803902C7.59568 0.803902 7.34433 0.894293 7.15841 1.08016L2.54598 5.69267ZM3.29301 11.0114C3.82308 11.5415 4.60437 11.6227 5.03466 11.1925L5.99787 10.2293L2.0036 6.23504L1.04039 7.19826C0.610145 7.6285 0.69138 8.40978 1.22148 8.93988L3.29301 11.0114Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_95_15778">
        <rect width="12.2727" height="12.2727" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

type Props = Readonly<{
  mode: ScratchPadMode;
  setMode: (m: ScratchPadMode) => void;
  tool: ScratchPadTool;
  setTool: (t: ScratchPadTool) => void;
  undo: () => void;
  redo: () => void;
  clear: () => void;
  penColor: string;
  setPenColor: (c: string) => void;
  penSize: number;
  setPenSize: (n: number) => void;
  eraserSize: number;
  setEraserSize: (n: number) => void;
  onSelectTextMode: () => void;
  onCameraClick?: () => void;
}>;

const IconButton = ({
  active,
  label,
  onClick,
  children,
  underlineColor,
  showColorPicker,
}: Readonly<{
  active?: boolean;
  label: string;
  onClick: () => void;
  children: ReactNode;
  underlineColor?: string;
  showColorPicker?: boolean;
}>) => (
  <button
    type="button"
    aria-label={label}
    onClick={onClick}
    className={[
      "relative h-7 w-7 rounded-[6px] flex items-center justify-center transition-colors",
      showColorPicker
        ? "bg-gray-200 text-[#1C9C6D]"
        : active
          ? "text-[#1C9C6D]"
          : "text-[#1C9C6D]/70 hover:text-[#1C9C6D]",
    ].join(" ")}
  >
    {active && (
      <span
        className="absolute bottom-[2px] left-[8px] right-[8px] h-[3px] rounded-full"
        style={{ backgroundColor: underlineColor ?? "#0f172a" }}
      />
    )}
    {children}
  </button>
);

const colorOptions = [
  "#1E90FF", // Blue
  "#CC44CC", // Purple/Magenta
  "#F7931E", // Orange
  "#222222", // Black
  "#1E8E3E", // Green
];

export const ScratchPadToolbar = ({
  mode,
  setMode,
  tool,
  setTool,
  undo,
  redo,
  clear,
  penColor,
  setPenColor,
  penSize,
  setPenSize,
  eraserSize,
  setEraserSize,
  onSelectTextMode,
  onCameraClick,
}: Props) => {
  const [showColors, setShowColors] = useState(false);

  useEffect(() => {
    if (mode !== "draw" || tool !== "pen") setShowColors(false);
  }, [mode, tool]);

  return (
    <div className="relative flex flex-col items-center gap-2">
      <div
        className="rounded-[6.82px] bg-[#FBFBFB] flex items-center gap-[3px]"
        style={{
          border: "1.5px solid #ECECEC",
          boxShadow: "0px 0px 2.73px 0px #0000001A",
          padding: "3px 12px 3px 8px",
        }}
      >
        <IconButton
          active={mode === "draw" && tool === "pen"}
          label="Pen"
          onClick={() => {
            if (mode === "draw" && tool === "pen") {
              // Already on pen tool, toggle color picker
              setShowColors((prev) => !prev);
            } else {
              // First click, just select pen tool
              setMode("draw");
              setTool("pen");
              setShowColors(false);
            }
          }}
          underlineColor={penColor}
          showColorPicker={showColors && mode === "draw" && tool === "pen"}
        >
          <PencilIcon />
        </IconButton>

        <div
          className="h-[16.36px] w-0"
          style={{ borderLeft: "1.36px solid #02734A1A" }}
        />

        <IconButton
          active={mode === "text"}
          label="Text"
          onClick={() => {
            onSelectTextMode();
            setShowColors(false);
          }}
        >
          <TextBoxIcon />
        </IconButton>

        <div
          className="h-[16.36px] w-0"
          style={{ borderLeft: "1.36px solid #02734A1A" }}
        />

        <IconButton
          active={mode === "draw" && tool === "eraser"}
          label="Eraser"
          onClick={() => {
            setMode("draw");
            setTool("eraser");
            setShowColors(false);
          }}
        >
          <EraserIcon />
        </IconButton>

        {onCameraClick && (
          <>
            <div
              className="h-[16.36px] w-0"
              style={{ borderLeft: "1.36px solid #02734A1A" }}
            />
            <IconButton
              label="Scan paper"
              onClick={() => {
                onCameraClick();
                setShowColors(false);
              }}
            >
              <ImageIcon />
            </IconButton>
          </>
        )}

        <div
          className="h-[16.36px] w-0"
          style={{ borderLeft: "1.36px solid #02734A1A" }}
        />

        <div
          className="flex h-[18px] w-[18px] items-center justify-center ml-[8px] rounded-[3px] bg-white"
          style={{ boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.1)" }}
        >
          <IconButton
            label="Undo"
            onClick={() => {
              undo();
              setShowColors(false);
            }}
          >
            <Undo2 className="h-[15px] w-[15px]" />
          </IconButton>
        </div>

        <div
          className="flex h-[18px] w-[18px] items-center justify-center rounded-[3px] ml-[4px] bg-white"
          style={{ boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.1)" }}
        >
          <IconButton
            label="Redo"
            onClick={() => {
              redo();
              setShowColors(false);
            }}
          >
            <Redo2 className="h-[15px] w-[15px]" />
          </IconButton>
        </div>
      </div>

      {showColors && (
        <div className="absolute top-full mt-2 z-10 rounded-[12px] border border-slate-200 shadow-sm bg-white px-3 py-[6px] flex items-center gap-2">
          {colorOptions.map((color) => (
            <button
              key={color}
              type="button"
              aria-label={`Set pen color ${color}`}
              onClick={() => {
                setMode("draw");
                setTool("pen");
                setPenColor(color);
                setShowColors(false);
              }}
              className={[
                "h-5 w-5 rounded-full flex items-center justify-center border border-white",
                penColor === color ? "ring-2 ring-emerald-600" : "",
              ].join(" ")}
              style={{ backgroundColor: color }}
            />
          ))}
          {/* Color Picker */}
          <label
            className={[
              "h-5 w-5 rounded-full flex items-center justify-center border border-white cursor-pointer overflow-hidden relative",
              !colorOptions.includes(penColor) ? "ring-2 ring-emerald-600" : "",
            ].join(" ")}
            style={{
              background:
                "linear-gradient(180deg, #FF0003 0%, #1534FF 50%, #00FF4D 100%)",
            }}
          >
            <input
              type="color"
              value={penColor}
              onChange={(e) => {
                setMode("draw");
                setTool("pen");
                setPenColor(e.target.value);
              }}
              className="opacity-0 w-0 h-0 absolute"
            />
          </label>
        </div>
      )}
    </div>
  );
};
